/* jshint esversion: 6 */
import Vue from "vue";
import Router from "vue-router";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
const Home = (r) => require.ensure([], () => r(require("./views/home/home.vue")), "Home");
const freshHome = (r) => require.ensure([], () => r(require("./views/freshHome/freshHome.vue")), "freshHome");
const downapp = (r) => require.ensure([], () => r(require("./views/app/ylsq/downApp/downapp.vue")), "downapp");

import * as common from "./views/common";
import * as category from "./views/category";
import * as chains from "./views/chains";
import * as limit from "./views/limit";
import * as user from "./views/user";
import * as cart from "./views/cart";
import * as me from "./views/me";
import * as search from "./views/search";
import * as item from "./views/item";
import * as order from "./views/order/";
import * as address from "./views/address";
import * as pickup from "./views/app/ylsq/pickup";
import * as others from "./views/others";
import * as invitation from "./views/app/ylsq/invitation";
import * as yzg from "./views/app/yzg";
import * as ylsq from "./views/app/ylsq";
import * as shop from "./views/shop";
import * as coupon from "./views/coupon";
import * as returnGoods from "./views/returnGoods";
import * as school from './views/school'
import * as performance from './views/performance'


// 外层模板_含tabbar
const TabbarRoutes = [
  {
    path: "/",
    component: common.tabbar,
  },
];

// 外层模板
const LayoutRoutes = [
  {
    path: "/",
    component: common.layout,
  },
];

// 首页
const HomeRoutes = [
  {
    path: "/",
    component: common.tabbar,
    children: [
      {
        path: "/",
        name: "home",
        component: Home,
        meta: {
          title: "邮乐优鲜",
        },
      },
      {
        path: "freshHome",
        name: "freshHome",
        component: freshHome,
        redirect: "/",
        meta: {
          title: "邮乐优鲜",
        },
      },
    ],
  },
];

// 入口页-1.登录 2.找回密码
const userRoutes = [
  {
    path: "/user",
    component: common.layout,
    children: [
      {
        path: "login",
        name: "login",
        meta: {
          title: "登录",
        },
        component: user.userLogin,
      },
      {
        path: "retrieve",
        name: "retrieve",
        meta: {
          title: "找回密码",
        },
        component: user.userRetrieve,
      },
      {
        path: "orgInfo",
        name: "orgInfo",
        meta: {
          title: "接龙活动",
        },
        component: user.orgInfo,
      },
    ],
  },
];

// 入口页-1.收货地址列表  2.新增收货地址 3.修改收货地址
const addressRoutes = [
  {
    path: "/address",
    component: common.layout,
    children: [
      {
        path: "addressList",
        name: "addressList",
        meta: {
          title: "收货地址",
        },
        component: address.addressList,
      },
      {
        path: "editAddress",
        name: "editAddress",
        meta: {
          title: "修改收货地址",
        },
        component: address.editAddress,
      },
    ],
  },
];

// 分类
const categoryRoutes = [
  {
    path: "/category",
    component: common.layout,
    children: [
      {
        path: "categoryList",
        name: "categoryList",
        meta: {
          title: "分类",
        },
        component: category.categoryList,
      },
    ],
  },
];

// vi页
const viRoutes = [
  {
    path: "/item",
    component: common.layout,
    children: [
      {
        path: "itemPage/:listId",
        name: "itemPage",
        meta: {
          title: "商品详情",
        },
        component: item.itemPage,
      },
      {
        path: "comment/:listId",
        name: "itemComment",
        meta: {
          title: "商品评论",
          keepAlive: true,
        },
        component: item.itemComment,
      },
    ],
  },
];

// 下单页
const orderRoutes = [
  {
    path: "/order",
    component: common.layout,
    children: [
      {
        path: "orderConfirm",
        name: "orderConfirm",
        meta: {
          title: "订单确认",
        },
        component: order.orderConfirm,
      },
      {
        path: "orderList",
        name: "orderList",
        meta: {
          title: "我的订单",
          keepAlive: true,
        },
        component: order.orderList,
      },
      {
        path: "orderInfo/:escOrderId",
        name: "orderInfo",
        meta: {
          title: "订单详情",
        },
        component: order.orderInfo,
      },
      {
        path: "logistics/:packageId",
        name: "logistics",
        meta: {
          title: "物流",
        },
        component: order.logistics,
      },
    ],
  },
];

// 购物车
const cartRoutes = [
  {
    path: "/cart",
    component: common.layout,
    children: [
      {
        path: "cartList",
        name: "cartList",
        meta: {
          title: "购物车",
        },
        component: cart.cartList,
      },
    ],
  },
];

// 个人中心
const meRoutes = [
  {
    path: "/me",
    component: common.layout,
    children: [
      {
        path: "userCenter",
        name: "userCenter",
        meta: {
          title: "邮乐优鲜-个人中心",
        },
        component: me.userCenter,
      },
      {
        path: "personalData",
        name: "personalData",
        meta: {
          title: "邮乐优鲜-个人资料",
        },
        component: me.personalData,
      },
    ],
  },
];

// 搜索模块
const searchRoutes = [
  {
    path: "/search",
    component: common.layout,
    children: [
      {
        path: "searchList",
        name: "searchList",
        meta: {
          title: "搜索",
        },
        component: search.searchList,
      },
    ],
  },
];

// 定位失败引导页
const othersRoutes = [
  {
    path: "/others",
    component: common.layout,
    children: [
      // 定位丢失页
      {
        path: "positionLost",
        name: "positionLost",
        component: others.positionLost,
      },
      // 404页
      {
        path: "pageLost",
        name: "pageLost",
        component: others.pageLost,
      },
      // 首页切换定位中转页
      {
        path: "indexPick",
        name: "indexPick",
        component: others.indexPick,
      },
    ],
  },
];

// 自提模块
const pickupRoutes = [
  {
    path: "/pickup",
    component: common.layout,
    children: [
      {
        path: "pickupList",
        name: "pickupList",
        meta: {
          title: "自提订单列表",
          keepAlive: true,
        },
        component: pickup.pickupList,
      },
      {
        path: "pickupDetail",
        name: "pickupDetail",
        meta: {
          title: "自提订单详情",
        },
        component: pickup.pickupDetail,
      },
      {
        path: "pickupLogistics",
        name: "pickupLogistics",
        meta: {
          title: "自提物流详情",
        },
        component: pickup.pickupLogistics,
      },
      {
        path: "pickupSearch",
        name: "pickupSearch",
        meta: {
          title: "自提详情搜索",
        },
        component: pickup.pickupSearch,
      },
      {
        path: "pointList",
        name: "pointList",
        meta: {
          title: "我的自提点",
        },
        component: pickup.pointList,
      },
      {
        path: "pointAdd",
        name: "pointAdd",
        meta: {
          title: "添加自提点",
        },
        component: pickup.pointAdd,
      },
      {
        path: "pointEdit/:siteId",
        name: "pointEdit",
        meta: {
          title: "修改自提点",
        },
        component: pickup.pointEdit,
      },
    ],
  },
];

// 邀请模块
const invitationRoutes = [
  {
    path: "/invitation",
    component: common.layout,
    children: [
      {
        path: "join",
        name: "join",
        meta: {
          title: "邮乐优鲜",
        },
        component: invitation.invitationJoin,
      },
      {
        path: "new",
        name: "new",
        meta: {
          title: "邮乐优鲜",
        },
        component: invitation.invitationNew,
      },
    ],
  },
  {
    path: "/downapp",
    component: common.layout,
    children: [
      {
        path: "ylsq",
        name: "downapp",
        meta: {
          title: "邮乐优鲜",
        },
        component: downapp,
      },
    ],
  },
];

// 邮掌柜app分类
const yzgCategoryRoutes = [
  {
    path: "/yzgCategory",
    component: common.layout,
    children: [
      {
        path: "categoryList",
        name: "yzgCategoryList",
        meta: {
          title: "分类",
        },
        component: yzg.yzgCategoryList,
      },
    ],
  },
  {
    path: "/yzg",
    component: common.layout,
    children: [
      {
        path: "group",
        name: "group",
        meta: {
          title: "有团",
        },
        component: yzg.yzgGroup,
      },
      {
        path: "editGroup/:activityId",
        name: "editGroup",
        component: yzg.yzgEditGroup,
      },
      {
        path: "copy",
        name: "copy",
        meta: {
          title: "复制已有团",
        },
        component: yzg.yzgCopy,
      },
    ],
  },
];

// 邮乐优鲜app分类
const ylsqRoutes = [
  {
    path: "/ylsq",
    component: common.layout,
    children: [
      {
        path: "group",
        name: "ylsqGroup",
        meta: {
          title: "接龙",
        },
        component: ylsq.ylsqGroup,
      },
      {
        path: "editGroup/:activityId",
        name: "ylsqEditGroup",
        component: ylsq.ylsqEditGroup,
      },
      {
        path: "copy",
        name: "ylsqCopy",
        meta: {
          title: "复制已有团",
        },
        component: ylsq.ylsqCopy,
      },
      {
        path: "salesData",
        name: "salesData",
        meta: {
          title: "销售数据",
        },
        component: ylsq.salesData,
      },
      {
        path: "income",
        name: "income",
        meta: {
          title: "创业收益",
        },
        component: ylsq.income,
      },
      {
        path: "customer",
        name: "customer",
        meta: {
          title: "店铺顾客",
        },
        component: ylsq.customer,
      },
      {
        path: "customerList",
        name: "customerList",
        component: ylsq.customerList,
      },
      {
        path: "customerSee",
        name: "customerSee",
        component: ylsq.customerSee,
      },
      {
        path: "signScan",
        name: "signScan",
        meta: {
          title: "自提点到货签收",
        },
        component: ylsq.signScan,
      },
      {
        path: "signBatch",
        name: "signBatch",
        meta: {
          title: "订单核销",
        },
        component: ylsq.signBatch,
      }
    ],
  },
];

// 商家店铺页
const shopRoutes = [
  {
    path: "/shop",
    component: common.layout,
    children: [
      {
        path: "store/:storeId",
        name: "store",
        meta: {
          title: "商家店鋪",
        },
        component: shop.store,
      },
    ],
  },
];

// 接龙模块
const chainsRoutes = [
  {
    path: "/chains",
    component: common.layout,
    children: [
      {
        path: "chainsDetail/:activityId",
        name: "chainsDetail",
        component: chains.chainsDetail,
      },
    ],
  },
];
// 秒杀模块
const limitRoutes = [
  {
    path: "/limit",
    component: common.layout,
    children: [
      {
        path: "list",
        name: "limitList",
        meta: {
          title: "限时秒杀",
        },
        component: limit.limitList,
      },
    ],
  },
];
// 优惠券
const couponPage = [
  {
    path: "/coupon",
    component: common.layout,
    children: [
      {
        path: "userConpon",
        name: "userConpon",
        meta: {
          title: "我的优惠券",
          keepAlive: true,
        },
        component: coupon.userConpon,
      },
      {
        path: "couponCenter",
        name: "couponCenter",
        meta: {
          title: "领券中心",
          keepAlive: true,
        },
        component: coupon.couponCenter,
      },
      {
        path: "couponTurn",
        name: "couponTurn",
        meta: {
          title: "我有大把优惠券送你们",
          keepAlive: true,
        },
        component: coupon.couponTurn,
      },
    ],
  },
];
// 退货查询
const returnGoodsRoutes = [
  {
    path: "/returnGoods",
    component: common.layout,
    children: [
      {
        path: "list",
        name: "returnGoodsList",
        meta: {
          title: "退货清单",
        },
        component: returnGoods.list,
      },
      {
        path: "orderList",
        name: "returnGoodsOrderList",
        meta: {
          title: "退货订单",
        },
        component: returnGoods.orderList,
      },
      {
        path: "pickingList",
        name: "returnGoodsPickingList",
        meta: {
          title: "取货明细",
        },
        component: returnGoods.pickingList,
      },
      {
        path: "photoList",
        name: "returnGoodsPhotoList",
        meta: {
          title: "取货照片",
        },
        component: returnGoods.photoList,
      },
    ],
  },
];
const schoolRoute = [
  {
    path:'/school',
    component: common.layout,
    children:[
      {
        path:'schoolList',
        name:'schoolList',
        meta: {
          title: "微课堂",
        },
        component: school.schoolList,
      }
    ]
  }
]

const performanceRoutes = [
  {
    path:'/',
    component: common.layout,
    children:[
      {
        path:'performance',
        name:'performance',
        meta: {
          title: "我的优鲜团点",
        },
        component: performance.index,
      }
    ]
  }
]



// 全局引入
const routes = [
  ...HomeRoutes, 
  ...LayoutRoutes, 
  ...TabbarRoutes, 
  ...categoryRoutes, 
  ...cartRoutes, 
  ...meRoutes, 
  ...searchRoutes, 
  ...viRoutes, 
  ...userRoutes, 
  ...orderRoutes, 
  ...addressRoutes, 
  ...othersRoutes, 
  ...pickupRoutes, 
  ...invitationRoutes, 
  ...yzgCategoryRoutes, 
  ...ylsqRoutes, 
  ...chainsRoutes, 
  ...shopRoutes, 
  ...couponPage, 
  ...limitRoutes, 
  ...returnGoodsRoutes,
  ...schoolRoute,
  ...performanceRoutes
];

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/yxd/community/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to, from) => {
  if (window.uleStatUtil) {
    let params = {};
    let sendView = true;
    if (to.name == "home" || to.name == "indexPick") {
      // 到路由页面里单独提交PV
      sendView = false;
    } else if (to.name == "itemPage") {
      params.listId = to.params.listId;
    } else if (to.name == "store") {
      params.storeId = to.params.storeId;
    }
    if (sendView) {
      setTimeout(() => {
        uleStatUtil.sendView(location.href, params);
      }, 100);
    }
  }
});

export default router;
